"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    icon: {
        fontSize: 24,
        color: theme.palette.text.primary,
        marginRight: 4
    },
    centered: {
        display: 'flex',
        justifyContent: 'flex-start',
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center'
        }
    }
});
exports.default = styles;
//# sourceMappingURL=YoullEarnMsgStyles.js.map